import { render, staticRenderFns } from "./Construccion.vue?vue&type=template&id=7b77bdc2&"
import script from "./Construccion.vue?vue&type=script&lang=js&"
export * from "./Construccion.vue?vue&type=script&lang=js&"
import style0 from "./Construccion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports